import { legacy_createStore as createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import user from "./reducers/user"

export default createStore(combineReducers({
	user
}), compose(applyMiddleware(thunk)))